// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalWork_modal__2z5q4","container":"ModalWork_container__1kdmr","modalClose":"ModalWork_modalClose__3P_Xk"};